// src/PrivacyPolicy.js

import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
// import { IMAGES } from "../assets/img/ImageIndex";

function PrivacyPolicy() {
  useEffect(() => {
    // Set document title and meta tags
    document.title = 'Privacy Policy for Small Business Loans | EnvoCapital';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Read how EnvoCapital collects, uses, and protects information submitted through our small business loans and business financing USA applications, including contact and business details.');
    }
  }, []);

  return (
    <div className="loan-program-page">
        {/* <div className="page-banner-area bg-gray2">
            <div className="container mw-1380">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="page-banner-content">
                            <ul className="ps-0 list-unstyled breadcrumbs">
                                <li><Link to="/">Home</Link></li>
                                <li>Privacy Policy</li>
                            </ul>
                            <h1>Mortgage Miracles: Transforming Dreams into Dwellings in the Real Estate Universe</h1>
                            <p>We truly care about what is best for you! From pre-approval to closing, our goal is to provide you with the best service while saving you money. We provide a completely customized experience, and will find the right loan program and best terms for you.</p>
                            <Link to="/calculate-mortgage/" className="read-more text-primary">
                                Calculate Your Payments
                                <i className="fi fi-rs-arrow-right"></i>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="page-banner-img text-center text-lg-end position-relative z-1">
                            <img src={IMAGES.bannerImg5} className="img" alt="banner-img"/>
                            <img src={IMAGES.shape7} className="shape shape-7" alt="Shape1"/>
                            <img src={IMAGES.shape8} className="shape shape-8" alt="Shape2"/>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}
      
        <div className="page-main-content ptb-130">
            <div className="page-area ">
                <div className="container">
                    <div id="post-3" className="post-3 page type-page status-publish hentry">
                        <div className="entry-content">
                            <p>Last updated: November 2025</p>

                            <h3 className="wp-block-heading">Privacy Policy</h3>
                            <p>
                                At EnvoCapital, we are committed to protecting your personal information and ensuring complete transparency 
                                in how we collect, use, and safeguard your data. This Privacy Policy outlines our practices regarding data handling, 
                                user rights, and security. If you have any questions, contact us at info@envocapital.com.
                            </p>
                            <p>
                                We value your trust and are dedicated to maintaining the privacy and confidentiality of your information throughout 
                                our relationship with you. Our policies apply to all users interacting with our website, online applications, 
                                communication channels, and financial services.
                            </p>

                            <h3 className="wp-block-heading">What type of personal information do we collect?</h3>
                            <p>
                                We collect information necessary to verify your identity, evaluate your financing eligibility, and deliver our 
                                services effectively. This may include your name, business information, contact details, financial data, application 
                                information, documents you upload, and any communication you share with us.
                            </p>
                            <p>
                                Additionally, we may collect technical information such as IP addresses, usage patterns, device identifiers, and 
                                analytical data to enhance the security and performance of our digital platforms.
                            </p>
                            <p>
                                All information is collected lawfully, fairly, and only for purposes essential to providing financial services.
                            </p>

                            <h3 className="wp-block-heading">How do we collect your personal data?</h3>
                            <p>
                                We gather data directly from you when you fill out forms, submit loan applications, request consultations, communicate 
                                with our team, subscribe to updates, or interact with our website.
                            </p>
                            <p>We may also receive information indirectly through:</p>
                            <ol className="wp-block-list">
                                <li>Third-party partners assisting with verification</li>
                                <li>Credit bureaus (where permitted)</li>
                                <li>Public databases</li>
                                <li>Cookies or tracking tools used to improve website performance</li>
                            </ol>
                            <p>
                                Additional data may be collected when you upload financial or identification documents, engage with marketing emails, 
                                navigate our website, use interactive tools, or authorize third-party integrations.
                            </p>
                            <p>
                                We do not collect more information than necessary to fulfill legitimate business or legal requirements.
                            </p>

                            <h3 className="wp-block-heading">What are our legal bases for processing your data?</h3>
                            <p>
                                We process your information only when we have a lawful reason to do so. Our primary legal bases include:
                            </p>
                            <ol className="wp-block-list">
                                <li><strong>Contractual necessity:</strong> To evaluate, process, and manage your financing request.</li>
                                <li><strong>Legitimate interest:</strong> To improve our services, prevent fraud, and ensure security.</li>
                                <li><strong>Legal compliance:</strong> To meet regulatory, reporting, and documentation obligations.</li>
                                <li><strong>Consent:</strong> When you voluntarily submit information or opt in to communications.</li>
                            </ol>
                            <p>
                                Your data is processed with care and clarity, ensuring that each purpose aligns with industry standards and legal 
                                frameworks.
                            </p>

                            <h3 className="wp-block-heading">Security</h3>
                            <p>
                                We employ strict technical and organizational safeguards to protect your data from unauthorized access, alteration, 
                                disclosure, or loss. This includes encryption, secure servers, access controls, monitoring systems, and third-party 
                                compliance checks.
                            </p>
                            <p>
                                While no digital system can guarantee absolute security, our protocols are designed to exceed industry expectations 
                                and maintain the confidentiality of your financial and personal information.
                            </p>
                            <p>
                                If you suspect any compromise of your data, please contact us immediately at info@envocapital.com.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default PrivacyPolicy;
